
<div class="form__group--border py-16 pb-32">
  <legend class="form__label pb-4">{{ legendText }}</legend>
  <poppins-text-field
    id="years-experience"
    ref="yearsExperienceTextField"
    v-model="yearsExperience"
    labelName="Years of experience"
    :aria-label="legendText"
    name="years-experience"
    type="text"
    pattern="\d{1,2}"
    inputmode="numeric"
    :status="formStatuses.yearsExperience"
    :required="true"
    :helperText="helperText(formStatuses.yearsExperience)"
    @blur="validate"
  />
</div>
